import { CREATE_AFTERMARKET_PRODUCTS } from './createAftermarketProduct';
import { UPDATE_AFTERMARKET_PRODUCTS } from './updateAftermarketProduct';
import { UPSERT_AFTERMARKET_DOCUMENT } from './upsertAftermarketDocument';
import { DELETE_AFTERMARKET_DOCUMENT } from './deleteAftermarketDocument';

import { GET_PARTNER_LINKS } from './getPartnerLincks';
import { GET_AFTERMARKET_PRODUCT_BY_ID } from './getAftermarketProductsById';
import { GET_AFTERMARKET_PRODUCTS } from './getListAftermarketProductsByAccount';
import { GET_AFTERMARKET_ADDONS_PRODUCTS_OPTIONS } from './getListAddonsOptionsByAccount';
import { GET_AFTERMARKET_PRODUCT_DOCUMENTS } from './getDocumentsByAftermarketProductId';

export const aftermarketProductsApi = {
  createProduct: CREATE_AFTERMARKET_PRODUCTS,
  updateProduct: UPDATE_AFTERMARKET_PRODUCTS,
  upsertDocument: UPSERT_AFTERMARKET_DOCUMENT,
  deleteDocument: DELETE_AFTERMARKET_DOCUMENT,

  getPartnerLinks: GET_PARTNER_LINKS,
  getProductsById: GET_AFTERMARKET_PRODUCT_BY_ID,
  getListProductsByAccountId: GET_AFTERMARKET_PRODUCTS,
  getAddonsOptionsByAccountId: GET_AFTERMARKET_ADDONS_PRODUCTS_OPTIONS,
  getDocumentsByAftermarketProductId: GET_AFTERMARKET_PRODUCT_DOCUMENTS,
};
